import React from "react";
import PropTypes from "prop-types";
import SellOutGoldenStoresDesktop from "./SellOutGoldenStoresDesktop";

function SellOutGoldenStores({ app, config }) {
  return <SellOutGoldenStoresDesktop app={app} config={config} />;
}

SellOutGoldenStores.defaultProps = {
  app: null,
  config: {},
};

SellOutGoldenStores.propTypes = {
  app: PropTypes.object,
  config: PropTypes.object,
};

export default SellOutGoldenStores;
